'use strict';

export default class cvIncreaseViewCount {
    constructor(options) {
        this.opt = options;
        this.bindHandlers();
    }

    bindHandlers() {
        var self = this;
        $.post(self.opt.url + '?time=' + $.now());
    }
}